import { DeliveryPointBaseModel } from '../../api/data-contracts';
import { ExtendDeliveryPointBaseModel } from './types';

export const enrichPointsWithIdByType =
  (pointsType: string) =>
  <T extends DeliveryPointBaseModel>(points: T[]): ExtendDeliveryPointBaseModel<T>[] =>
    points.map((item) => ({
      ...item,
      id: `${pointsType}-${item.id}`,
      pointId: item.id,
    }));
